import { modelHelperModule } from './model-helper';
import { unique } from '../utils/array-utils';

export const assessmentCohortModelModule = angular
  .module('Q.models.assessment-cohort', [modelHelperModule])

  .factory('AssessmentCohort', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'AssessmentCohort',
      endpoint: 'assessment_cohorts',

      relations: {
        belongsTo: {
          Assessment: {
            localField: 'assessment',
            localKey: 'assessmentId',
          },
          Team: {
            localField: 'team',
            localKey: 'teamId',
          },
        },
        hasMany: {
          TeamCandidate: {
            localField: 'teamCandidates',
            localKeys: 'teamCandidateIds',
          },
        },
      },
      meta: {},
      afterInject(resource, instance) {
        ModelHelper.afterInject(resource, instance);
        // after we inject or update a solution, we should always remove any cached revisions,
        // because they will never be updated
        const _afterInject = (instance) => {
          instance.allEmails = unique(
            [].concat(
              instance.pendingEmails,
              instance.rejectedEmails,
              instance.invitedEmails,
            ),
          );
          const total = (instance.total = instance.allEmails.length);
          instance.pending = instance.pendingEmails.length;
          instance.sent = instance.invitedEmails.length;
          instance.rejected = instance.rejectedEmails.length;
          instance.progress = (100 * (total - instance.pending)) / total;
          instance.complete = instance.state === 'completed';
          instance.incomplete = !instance.complete;
        };
        if (Array.isArray(instance)) {
          instance.forEach(_afterInject);
        } else {
          _afterInject(instance);
        }
      },
    });
  });
